import { ProductTag } from '~/shared/constants/products';

import { MEMBERSHIP_STATES } from '../constants/product';

export const getMembershipExcludedTagIds = (membership) => {
  let filteredTagIds = [];
  switch (membership) {
    case MEMBERSHIP_STATES.ELITE:
    case MEMBERSHIP_STATES.VIP:
      filteredTagIds = [ProductTag.leadOnly];
      break;
    case MEMBERSHIP_STATES.VISITOR:
    case MEMBERSHIP_STATES.LEAD:
      filteredTagIds = [ProductTag.vipOnly];
      break;
    default:
      break;
  }

  return filteredTagIds;
};
